import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import "../style/JoinCommunity.css";


const JoinCommunity = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        city: "",
        title: "",
        news: "",
    });
    
const [loading, setLoading] = useState(false);
const [showPopup, setShowPopup] = useState(false);


  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    await addDoc(collection(db, "communityPosts"), {
      ...form,
      createdAt: Timestamp.now(),
    });

    setShowPopup(true);
    setForm({
      name: "",
      email: "",
      city: "",
      title: "",
      news: "",
    });
  } catch (error) {
    console.error(error);
  }

  setLoading(false);
};


  return (
    <section className="join-community">
      <h2>Join Our Auto Community</h2>
      <p>Share your automotive news and experiences</p>

      <form onSubmit={handleSubmit} className="community-form">
        <input
          name="name"
          placeholder="Full Name"
          onChange={handleChange}
          required
        />

        <input
          name="email"
          type="email"
          placeholder="Email Address"
          onChange={handleChange}
          required
        />

        <input
          name="city"
          placeholder="City"
          onChange={handleChange}
          required
        />

        <input
          name="title"
          placeholder="News Title"
          onChange={handleChange}
          required
        />

        <textarea
          name="news"
          placeholder="Write your news or review here..."
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Join Community"}
        </button>
      </form>
      {showPopup && (
  <div className="popup-overlay">
    <div className="popup-card">
      <h3>🎉 Submission Successful!</h3>
      <p>
        Thank you for joining our auto community.  
        Your post has been submitted for review.
      </p>

      <button onClick={() => setShowPopup(false)}>
        Close
      </button>
    </div>
  </div>
)}

    </section>
  );
};

export default JoinCommunity;
